import React from 'react';
import OptimizerList from '../../elements/Body/OptimizerList/OptimizerList';
import './OptimizerListPage.css';
class OptimizerListPage extends React.Component {
  render() {
    return (
      <>
        <OptimizerList />
      </>
    );
  }
}
export default OptimizerListPage;
